import { useMemo } from 'react'
import type { UserAnswerDraft, UserAnswersDraft } from '../../state/types'

export interface UserAnswerDraftEntry {
  readonly header: string
  readonly answer: UserAnswerDraft
  readonly index: number
}

export function useUserAnswerDraftEntries(
  userAnswersDraft: UserAnswersDraft | null,
): readonly UserAnswerDraftEntry[] {
  return useMemo(() => {
    if (!userAnswersDraft) return []
    return Object.entries(userAnswersDraft.answers)
      .filter(([, answer]) => answer.customAnswer !== null && answer.customAnswer.trim() !== '')
      .map(([header, answer], index) => ({ header, answer, index }))
  }, [userAnswersDraft])
}
